import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "animated" }
const _hoisted_2 = { class: "col-md-7" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", null, "Global Search")
], -1)
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = { class: "input-group" }
const _hoisted_6 = { class: "input-group-append" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "mx-auto text-center d-flex justify-center row items-center mt-20" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-7 el-col-offset-5" }, [
  /*#__PURE__*/_createElementVNode("h2", {
    class: "",
    style: {"font-family":"'Courier New', Courier, monospace","font-size":"xxx-large"}
  }, "Global Search"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-right" }, [
    /*#__PURE__*/_createElementVNode("small", null, [
      /*#__PURE__*/_createTextVNode("powered by AI "),
      /*#__PURE__*/_createElementVNode("i", {
        class: "bi bi-stars",
        style: {"color":"plum"}
      })
    ])
  ])
], -1)
const _hoisted_10 = { class: "text-center col-md-7 el-col-offset-5 mt-10" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "input-group" }
const _hoisted_13 = { class: "input-group-append" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "mt-5 text-left items-start d-flex" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-gray-700" }, " Suggestions ")
], -1)
const _hoisted_15 = { class: "d-flex row" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 mt-2 mb-2 py-3" }, [
  /*#__PURE__*/_createTextVNode(" SSRF "),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 mt-2 mb-2 py-3" }, [
  /*#__PURE__*/_createTextVNode(" Live "),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-100 mt-2 mb-2 py-3" }, [
  /*#__PURE__*/_createTextVNode(" Mobile "),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { class: "text-gray-500 mt-2 mb-2" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "bg-gray-100 mt-2 mb-2 px-5 py-5" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/cam.svg",
  alt: "",
  style: {"width":"50px"}
}, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "bg-gray-100 mt-2 mb-2 px-5 py-5" }
const _hoisted_31 = ["src"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_33 = { class: "badge badge-light mx-1" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "bg-gray-100 mt-2 mb-2 px-5 py-5 col-md-12" }
const _hoisted_36 = { class: "px-2 py-2" }
const _hoisted_37 = ["src"]
const _hoisted_38 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_39 = ["src"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_42 = { key: 1 }
const _hoisted_43 = /*#__PURE__*/_createTextVNode()
const _hoisted_44 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_45 = ["href"]
const _hoisted_46 = /*#__PURE__*/_createElementVNode("small", { class: "bi bi-github" }, null, -1)
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_49 = ["href"]
const _hoisted_50 = /*#__PURE__*/_createElementVNode("small", { class: "bi bi-linkedin" }, null, -1)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = ["onClick"]
const _hoisted_53 = { class: "bg-gray-100 mt-2 mb-2 px-5 py-5" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/joy.svg",
  alt: "",
  style: {"width":"50px","border-radius":"50%"}
}, null, -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_56 = ["onClick"]
const _hoisted_57 = { class: "bg-gray-100 mt-2 mb-2 px-5 py-5" }
const _hoisted_58 = ["src"]
const _hoisted_59 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.responseTime)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.doSerach && _ctx.doSerach(...args)))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                  name: "search",
                  type: "text",
                  class: "form-control",
                  placeholder: "Search for SSRF, SSTI, Username, Machine Name..."
                }, null, 512), [
                  [_vModelText, _ctx.search]
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.doSerach && _ctx.doSerach(...args))),
                    class: "btn btn-secondary",
                    type: "button"
                  }, "Search")
                ])
              ])
            ])
          ])
        ], 32))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("form", {
            onSubmit: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.doSerach && _ctx.doSerach(...args)))
          }, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.search) = $event)),
                      name: "search",
                      type: "text",
                      class: "form-control",
                      placeholder: "Search for SSRF, SSTI, Username, Machine Name..."
                    }, null, 512), [
                      [_vModelText, _ctx.search]
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("button", {
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.doSerach && _ctx.doSerach(...args))),
                        class: "btn btn-secondary",
                        type: "button"
                      }, "Search")
                    ])
                  ])
                ]),
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", {
                    class: "col-md-4 cursor-pointer rounded-full",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.doPreSearch('SSRF')))
                  }, _hoisted_17),
                  _createElementVNode("div", {
                    class: "col-md-4 cursor-pointer rounded-full",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.doPreSearch('Live')))
                  }, _hoisted_19),
                  _createElementVNode("div", {
                    class: "col-md-4 cursor-pointer rounded-full",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.doPreSearch('Mobile')))
                  }, _hoisted_21)
                ])
              ])
            ]),
            _hoisted_22
          ], 32)
        ])),
    (_ctx.responseTime)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, " Response time: " + _toDisplayString(_ctx.responseTime > 0 ? _ctx.responseTime / 1000 : '') + " seconds ", 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results?.lessons, (result) => {
            return (_openBlock(), _createElementBlock("div", {
              key: result,
              onClick: ($event: any) => (_ctx.goTo('lesson', result)),
              class: "col-md-5 cursor-pointer"
            }, [
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createTextVNode(" " + _toDisplayString(result?.title) + " ", 1),
                _hoisted_28,
                _createElementVNode("small", null, _toDisplayString(result?.description), 1)
              ])
            ], 8, _hoisted_25))
          }), 128)),
          (_ctx.results?.machines?.length > 0)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.results?.machines, (result) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: result,
                  onClick: ($event: any) => (_ctx.goTo('machine', result)),
                  class: "col-md-5 cursor-pointer"
                }, [
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("img", {
                      src: result?.photo_path,
                      alt: "",
                      style: {"width":"50px"}
                    }, null, 8, _hoisted_31),
                    _createTextVNode(" " + _toDisplayString(result?.name) + " ", 1),
                    _hoisted_32,
                    _createElementVNode("small", null, _toDisplayString(result?.description), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(result?.tags, (tag) => {
                      return (_openBlock(), _createElementBlock("small", _hoisted_33, _toDisplayString(tag), 1))
                    }), 256))
                  ])
                ], 8, _hoisted_29))
              }), 128))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results?.users, (result) => {
            return (_openBlock(), _createElementBlock("div", {
              key: result,
              class: "d-flex col col-md-5 cursor-pointer",
              onClick: ($event: any) => (_ctx.goTo('user', result))
            }, [
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("img", {
                    src: result?.profile_photo_path,
                    alt: "",
                    style: {"width":"50px","border-radius":"50%"}
                  }, null, 8, _hoisted_37)
                ]),
                _createElementVNode("div", null, [
                  _createTextVNode(_toDisplayString(result?.nick || 'No nick') + " ", 1),
                  _hoisted_38,
                  (result?.patent)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: '/media/logos/badges/' + result?.patent?.icon,
                        alt: "",
                        style: {"width":"20px","height":"20px"}
                      }, null, 8, _hoisted_39))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(result?.patent?.name) + " ", 1),
                  _hoisted_40,
                  _hoisted_41,
                  (result?.bio)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_42, "Bio: " + _toDisplayString(result?.bio), 1))
                    : _createCommentVNode("", true),
                  _hoisted_43,
                  _hoisted_44,
                  (result?.github_url)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        target: "_blank",
                        class: "text-gray-900 fs-2",
                        href: 'https://github.com/' + result?.github_url
                      }, _hoisted_47, 8, _hoisted_45))
                    : _createCommentVNode("", true),
                  _hoisted_48,
                  (result?.linkedin_url)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 3,
                        target: "_blank",
                        class: "text-blue-900 fs-2",
                        href: 'https://www.linkedin.com/in/' + result?.linkedin_url
                      }, _hoisted_51, 8, _hoisted_49))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 8, _hoisted_34))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results?.challenges, (result) => {
            return (_openBlock(), _createElementBlock("div", {
              key: result,
              class: "col-md-5 cursor-pointer",
              onClick: ($event: any) => (_ctx.goTo('challenge', result))
            }, [
              _createElementVNode("div", _hoisted_53, [
                _hoisted_54,
                _createTextVNode(" " + _toDisplayString(result?.name) + " ", 1),
                _hoisted_55,
                _createElementVNode("small", null, _toDisplayString(result?.description), 1)
              ])
            ], 8, _hoisted_52))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results?.paths, (result) => {
            return (_openBlock(), _createElementBlock("div", {
              key: result,
              class: "col-md-5 cursor-pointer",
              onClick: ($event: any) => (_ctx.goTo('path', result))
            }, [
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("img", {
                  src: result?.image,
                  alt: "",
                  style: {"width":"150px"}
                }, null, 8, _hoisted_58),
                _createTextVNode(" " + _toDisplayString(result?.name) + " ", 1),
                _hoisted_59,
                _createElementVNode("small", null, _toDisplayString(result?.short_description), 1)
              ])
            ], 8, _hoisted_56))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}